import { UrlState } from "@/store/url/state";
import { ShareableUrl } from "@/models/url";

/**
 * Set the ShareableUrl object. This mutation should not be used directly.
 * Favor the updateUrl action to set new values. This will ensure the url and the state stay in sync.
 * @param state - Vuex state for the url module.
 * @param value - The ShareableUrl object.
 */
export function setUrl(state: UrlState, value: ShareableUrl): void {
  Object.assign(state, value);
}
